export default {
  username: 'نام کاربر',
  currentPhone: 'شماره فعلی در سامانه',
  newPhone: 'شماره جدید',
  userId: 'شناسه کاربر',
  swapIfExists: 'جابجایی در صورت وجود',
  swapped: 'شماره ها جابجا شد',
  changed: 'شماره کاربر تغییر کرد',
  submit: 'اعمال',
  show: 'نمایش تصاویر',
  hint: 'لطفا لینک های مورد نظر را در اینجا وارد کنید',
};
